<template>
  <div id="password-login-subview">
    <!-- <h4 style="padding-bottom: 1rem;">{{$t('sign-in:password-sign-in__title')}}</h4> -->
    <b-alert v-if="isLoginFailure" variant="info" show dismissible>{{$t('sign-in:failure')}}</b-alert>
    <b-form v-on:submit.prevent="login()" class="justify-content-center" style="margin-bottom: 1rem;">
      <b-form-group>
        <b-input v-model="email" class="mb-2 mr-sm-2 mb-sm-0" id="email-login__email" type="email" :placeholder="$t('common:email')" v-focus/>
      </b-form-group>
      <b-form-group>
        <b-input v-model="password" class="mb-2 mr-sm-2 mb-sm-0" id="email-login__password" type="password" :placeholder="$t('common:password')"/>
      </b-form-group>
      <b-button type="submit" :class="{loading: isLoginPending}" variant="primary" :disabled="!email || !password || isLoginPending">{{$t('sign-in:password-sign-in__button')}}</b-button>
    </b-form>
<!--    <p>Or try our <router-link to="email-login">passwordless sing in.</router-link></p> -->
    <p><router-link to="recover-password">{{$t('sign-in:password-sign-in__forget-link')}}</router-link></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      email: null,
      password: null,
      loginError: null,
      loading: false
    }
  },
  methods: {
    login: function () {
      this.$store.dispatch('login', {
        email: this.email,
        password: this.password
      }).then(res => {
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push('/personal/survey')
        }
      }).catch(() => {
        // Already handled through mutation
      })
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'isLoginPending', 'isLoginFailure'])
  }
}
</script>
